module.exports = __webpack_public_path__ + "img/title-line2.fb018a3a.png";